import { useDataSubmit, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })

  let stages = useDataValue({
    context: 'task',
    path: 'board.stages',
    viewPath: props.viewPath,
  })

  let task_id = useDataValue({
    context: 'task',
    path: 'id',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({
      type: 'set_task_stage',
      task_id,
      stage_id: stages.filter(stage => stage.text === 'Done')[0].id,
    })
  }
}
